
import React, { useState, useEffect, useMemo } from 'react';
import Dashboard from '../Dashboard';
import { showDataSol } from '../../../service/Contrato/showData';
import { useParams } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import StepperComp from '../../Stepper/StepperComp';
import IconStateFun from './SolicitudFUn/IconState';
import Typesol from './SolicitudFUn/Typesol';
import EmailChange from './SolicitudFUn/EmailChange';
import Contratobutton from './SolicitudFUn/Contratobutton';
import Contratobutton2 from './SolicitudFUn/Contratobutton2';
import Signature_contract from './SolicitudFUn/Signature_contract';
import { DeleteOrder } from './SolicitudFUn/DeleteOrder';
import { Loader } from '../../../Loader/Loader';
import { Orderfun } from './SolicitudFUn/Ordefun';
import { OrdeBuy } from './SolicitudFUn/OrdeBuy';
import { OrderEmp } from './SolicitudFUn/OrderEmp';
import { EditSol } from './SolicitudFUn/EditSol';
import DataTable from 'react-data-table-component';
import downloadCSV from './SolicitudFUn/downloadCSV';
import { Download } from 'iconoir-react';
import { domain } from '../../../Urls/Services/Api_urls';
import { ChangeOrder } from './SolicitudFUn/ChangeOrder';
import { DocumentSol } from './SolicitudFUn/DocumentsSol';
import { HistoricalSol } from './SolicitudFUn/HistoricalSol';
import { TrackingSol } from './SolicitudFUn/TrackingSol';

const formatFecha = (value) => (value ? String(value).slice(0, 10) : '');
const formatFechaHora = (value) =>
  value ? String(value).replace('T', ' ').slice(0, 19) : '';

export const OrdersBuy = (props) => {
  const parametrozona = useParams();
  const token = window.sessionStorage.getItem('token');
  const groups = window.sessionStorage.getItem('groups');
  const components = window.sessionStorage.getItem('components')?.split(',') || [];
  const [data, setData] = useState([]);
  const [step, setStep] = useState('none');
  const [steps, setSteps] = useState(null);
  const [estado, setEstado] = useState('Firmado');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(50);
  const [loading, setLoading] = useState(true);
  const [solicitud, setSolicitud] = useState([]);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [Caus, setCaus] = useState([]);
  const grupo = window.sessionStorage.getItem("grupo");
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');


  // useEffect(() => {
  //   fetchData(search, page);
  //   getData();
  //   getData1();
  // }, [token, page]); // Adjusted dependency array

  useEffect(() => {
    fetchData(search, 1, startDate, endDate);
    getData();
    getData1();
  }, [parametrozona.id, startDate, endDate, token, page]);  

  const fetchData = async (search, page, start = '', end = '') => {
    try {
      let url = `/portal/?zone=${parametrozona.id}&search=${search}&page=${page}&page_size=${perPage}`;
      if (start) {
        url += `&start_date=${start}`;
      }
      if (end) {
        url += `&end_date=${end}`;
      }
      const resultInfo = await showDataSol(
        'GET',
        token,
        url,
      )
      .then((resultinfo) => {
        setPerPage(50); // revisar limpieza de filtros
        setTotalRows(resultinfo.total_register);
        setSolicitud(resultinfo.data);
      })
      .finally(() => {
        validateState();
        setStep(groups === 'Usuario' ? '' : 'none');
        setLoading(false);
      })
      .catch((error) => console.log('error', error));
    } catch (error) {
      console.log('Error fetching data:', error);
    }
  };  

  const getData = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    const isCustomer = groups === "Usuario" || groups === "Usuario_Universidades";
    const causalUrl = isCustomer ? "/portal_causal/clientes/" : "/portal_causal/ventas/";
    fetch(domain + causalUrl, requestOptions)
      .then((data) => data.json())
      .then((data) => {
        setCaus(data.data);

      });
  };

  const getData1 = () => {
    console.log(groups);
    const stateValue = (groups === "vendedor_PAP" || groups === "facilitador_comercial") ? 2 : 1;
    const url = `${domain}/portal/plan/?state=${stateValue}`;
  
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      setData(data);
      console.log(data);
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
    });
  };

  const validateState = () => {
    if (estado === 'Por Firmar') {
      setSteps(1);
    } else if (estado === 'Firmado') {
      setSteps(2);
    } else if (estado === 'En Proceso') {
      setSteps(3);
    } else if (estado === 'Por Agendar') {
      setSteps(4);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    fetchData(search, newPage);
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
    fetchData(event.target.value, 1); // Always start from page 1 on new search
  };

  const Export = ({ onExport }) => (
    <>
    {groups !== "Usuario" ?
    <button 
    onClick={() => onExport(solicitud)} 
    className='p-1 cursor-pointer bg-colorprimarygreen text-white rounded-md hover:bg-colorsecondarygreen'>
      <Download /> 
      
    </button> : null}
    </>
  );

  const actionsMemo = useMemo(() => <Export onExport={downloadCSV} />, [solicitud]);

  const columns = [

    {
      name: "ACCIONES",
      width: "260px",
      cell: (row) => <div style={{ display: "flex", gap: "4px" }}>
        {(groups === 'Administrador' || components.includes('historico_solicitud')) && <HistoricalSol tableMeta={row} />}
        {(groups === 'Administrador' || components.includes('editar_solicitud')) && <EditSol tableMeta={row} planes={data} />}
        {(groups === 'Administrador' || components.includes('email_solicitud')) && <EmailChange tableMeta={row} />}
        {/* <Contratobutton tableMeta={row} /> */}
        {(groups === 'Administrador' || components.includes('ver_contrato_solicitud')) && <Contratobutton2 tableMeta={row} />}
        {(groups === 'Administrador' || components.includes('firmar_solicitud')) && <Signature_contract tableMeta={row} />}
        {(groups === 'Administrador' || components.includes('eliminar_solicitud')) && <DeleteOrder tableMeta={row} Causable={Caus} />}
        {(groups === 'Administrador' || components.includes('crear_orden_solicitud')) && <OrdeBuy tableMeta={row} />}
        {(groups === 'Administrador' || components.includes('empaquetar_solicitud')) && <OrderEmp tableMeta={row} />}
        {(groups === 'Administrador' || components.includes('cambiar_estado_solicitud')) && <ChangeOrder tableMeta={row} />}
        {(groups === 'Administrador' || components.includes('documentos_solicitud')) && <DocumentSol tableMeta={row} planes={data}/>}
        {(groups === 'Administrador' || components.includes('tracking_solicitud')) && <TrackingSol tableMeta={row} />}
      </div>,


    },
    {
      name: "TITULAR",
      width: "250px",
      selector: row => row.owner_name,
      sortable: true

    },
    {
      name: "ESTADO",
      width: "140px",
      selector: row => row.is_actived,
      sortable: true,
      cell: (row) =>
        <div style={{ textAlign: "center" }}>
          <IconStateFun tableMeta={row} />
        </div>

    },

    {
      name: "TIPO",
      width: "60px",
      center: true,
      cell: (row) => <div style={{ textAlign: "center" }}>
        <Typesol tableMeta={row} style={{ margin: 0, padding: 0, position: "static" }}/>
      </div>
    },

   
    {
      name: "DOCUMENTO",
      width: "130px",
      selector: row => row.cc,
      sortable: true
    },
    {
      name: "CELULAR",
      width: "110px",
      selector: row => row.contact_phone,
      sortable: true
    },
    {
      name: "FECHA SOLICITUD",
      width: "150px",
      selector: row => row.date_creation,
      format: row => formatFecha(row.date_creation),
      sortable: true
    },
    {
      name: "HORA",
      width: "100px",
      format: row => formatFechaHora(row.time_creation),
      selector: row => row.time_creation,
      sortable: true
    },
    {
      name: "FECHA ORDEN",
      width: "130px",
      selector: row => row.date_start_contract,
      format: row => formatFecha(row.date_start_contract),
      sortable: true
    },
    {
      name: "DIRECCION",
      width: "250px",
      selector: row => row.address,
      sortable: true
    },
    {
      name: "PLAN",
      width: "200px",
      selector: row => row.plan,
      sortable: true
    },
    
    {
      name: "CONTRATO",
      width: "120px",
      selector: row => row.contract,
      sortable: true
    },
    {
      name: "FIJO ASIGNADO",
      width: "140px",
      selector: row => row.phone_fijo,
      sortable: true
    },
    {
      name: "Encargado",
      selector: row => row.backoffice_manager,
      sortable: true
    },
    {
      name: "Vendedor",
      selector: row => row.seller_username,
      sortable: true
    },
  ];
  // const actionsMemo = useMemo(() => <Export onExport={downloadCSV} />, [solicitud]);
  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      setSearch('');
      setStartDate('');
      setEndDate('');
      setPerPage(50);
      setResetPaginationToggle(!resetPaginationToggle);
      fetchData('', 1, '', '');
    };
  
    return (
      <div className="flex flex-col gap-4 m-3 lg:flex-row lg:justify-end lg:items-center">
        {/* Búsqueda */}
        <div className="flex items-center bg-gray-200 rounded w-full max-w-sm">
          <input
            type="text"
            placeholder="Buscar..."
            value={search}
            onChange={handleSearchChange}
            className="flex-grow bg-gray-200 px-3 py-2 w-full outline-none rounded-l"
          />
          <button
            onClick={handleClear}
            className="bg-colorprimary text-white px-3 py-2 rounded-r"
          >
            ×
          </button>
        </div>

        {/* Filtro de fechas */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full sm:w-auto">
          <div className="flex items-center gap-1">
            <span className="text-gray-600 text-sm whitespace-nowrap">Desde:</span>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="text-gray-600 border px-2 py-1 rounded w-full sm:w-auto bg-gray-200"
            />
          </div>
          <div className="flex items-center gap-1">
            <span className="text-gray-600 text-sm whitespace-nowrap">Hasta:</span>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="text-gray-600 border px-2 py-1 rounded w-full sm:w-auto bg-gray-200"
            />
          </div>
        </div>

        {/* Botón de descarga */}
        <div className="flex justify-end w-full sm:w-auto">
          <a href='/Reportes/[S,N,C,O]'><Export /></a>
        </div>
      </div>


    );
  }, [search, resetPaginationToggle, startDate, endDate]);

  const paginationComponentOptions = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: false,
    selectAllRowsItemText: perPage,
  };

  return (
    <div style={{ overflowY: "auto" }}>
      <Dashboard
        MInicio=""
        Msolicitudes="active"
        Mservicios=""
        Mcompra=""
        Mcunyompra=""
        Mempaquetar=""
        Mcpotenciales=""
        Madminportal=""
        Mcampaña=""
      >
      <section className='mx-auto py-6 w-full'>
        <h2>Mis Solicitudes</h2>

        <div style={{ margin: '1rem', marginTop: '2rem'}}>
          <DataTable
            columns={columns}
            data={solicitud}
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
            paginationResetDefaultPage={resetPaginationToggle}
            progressPending={loading}
            // actions={actionsMemo}
            progressComponent={<Loader />}
            responsive
            fixedHeader
            pagination
            paginationRowsPerPageOptions={[perPage]}
            paginationServer
            paginationTotalRows={totalRows}
            paginationComponentOptions={paginationComponentOptions}
            onChangePage={handlePageChange}
          />
        </div>
      </section>
      </Dashboard>
    </div>
  );
};